import React from 'react';

import styled, { css } from 'styled-components';

import 'styles/global/_slick.scss';

import Slider from "react-slick";

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{ ...style}}
      onClick={onClick}
    >
      <img src="/icons/arrow.svg" alt="Next Slide Arrow Icon"/>
    </button>
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{ ...style}}
      onClick={onClick}
    >
      <img src={'/icons/arrow.svg'} alt="Previous Slide Arrow Icon" />
    </button>
  );
}

const PhotoGallery = ({ block, className }) => {

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    arrows: true,
    responsive: [
      {
        breakpoint: 930,
        settings: {
          arrows: false,
        }
      }
    ]
  }
  
  const { slide } = block;

  

  return (
    <Container>
      <Slider {...settings}>
        {
          slide.map((item) => (
            <img src={item.image[0].url} />
          ))
        }
      </Slider>
    </Container>
  )
};


export default PhotoGallery;

const Container = styled.section`
  max-width: ${({ theme }) => theme.content.CONTENT_WIDTH};
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 4em;
  margin-bottom: 8em;

  .slick-slider {
    width: 100%;
  }

  .slick-dots {
    bottom: -45px;
    li {
      margin: 0 1em;
    }
  }
  .slick-slide {
    > div {
      height: 500px;
      display: flex;
      justify-content: center;
      overflow: hidden;
    }
  }
  img {
    width: auto !important;
    height: 100%;
    display: block;
    ${( { focalPoint } ) =>
    focalPoint &&
      css`
        object-position: ${focalPoint[0] * 100 + '%'} ${focalPoint[1] * 100 + '%'};
      `
    };
  }
  .slick-arrow {
    height: 80px;
    background-color: ${({ theme }) => theme.colors.Primary}; 
    > img {
      height: 40px;
    }
  }
  .slick-prev {
    img {
      transform: rotate(180deg);
    }
  }
`;
